import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  // Ye hook humein current URL (path) deta hai
  const { pathname } = useLocation();

  useEffect(() => {
    // Jaise hi pathname change hoga, window top par scroll ho jayegi
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Ye component kuch render nahi karega, sirf logic chalayega
};

export default ScrollToTop;